<template>
    <div class="clearfix">
        <compWrapper
            theme="primary"
            :title="
                $t('global.common.base_information', {
                    defaultValue: '基本信息',
                })
            "
        >
            <compFormEdit
                class="padding-top-15"
                ref="form"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="130"
                :col="1"
            ></compFormEdit>
        </compWrapper>
        <compWrapper
            v-if="querytype == 'query'"
            theme="gray"
            :title="
                $t('global.common.operation_history', {
                    defaultValue: '操作历史',
                })
            "
        >
            <compLog
                class="margin-layout"
                :data="logList"
                :columns="logcolumn"
            ></compLog>
        </compWrapper>
        <div v-if="querytype != 'query'" class="margin-15 pull-right">
            <Button class="margin-right-15" type="primary" @click="submit">{{
                $t("global.common.save", { defaultValue: "保存" })
            }}</Button>
            <Button type="default" @click="$emit('on-close')">{{
                $t("global.common.operation_cancel", { defaultValue: "取消" })
            }}</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpGetBillingDetail,
    HttpGetCarrierGroup,
    HttpUpdateBillAccountDetail,
    HttpGetBillingAccount,
    HttpOrgServiceWarehouseList,
    HttpBillingAccountLog,
} from "@/service/carrieraccount.js";
import { mapState, mapGetters } from "vuex";
export default {
    props: ["activeid", "querytype"],
    data() {
        return {
            loading: false,
            formData: {
                isDefault: false,
            },
            carrierGroupList: [],
            billAccountList: [],
            warehouseList: [],
            logList: [],
            regionId:'',
        };
    },
    created() {
        HttpOrgServiceWarehouseList().then(
            (res) => {
                this.warehouseList = (res.data || []).map((item) => {
                    return {
                        value: item.id,
                        label: `${item.code}(${item.title})`,
                        attach:{
                            ...item
                        }
                    };
                });
            },
            (err) => {
                this.$VMessage.error(err.message);
            }
        );
        HttpGetCarrierGroup().then(
            (res) => {
                this.carrierGroupList = res.data.map((item) => {
                    return {
                        label: item.groupName,
                        value: item.id,
                        attach: {
                            ...item,
                        },
                    };
                });
            },
            (err) => {
                this.$VMessage.error(err.message);
            }
        );
        if (this.querytype !== "add") {
            this.getDetail();
            this.getLog();
        }
    },
    computed: {
        ...mapGetters("dictionary", [
            "getCarrierAllList",
            "getBillcusWareList",
            'getCustomServiceActiveList',
        ]),
        getBase() {
            let isQuery = this.querytype == "query";
            // console.log(isQuery);
            return [
                {
                    label: this.$t("global.common.warehouse", {
                        defaultValue: "仓库",
                    }),
                    key: "warehouseId",
                    tag: "vSelect",
                    options: this.warehouseList,
                    props: {
                        filterable: true,
                    },
                    on:{
                        'on-change':(val)=>{
                            this.getRegion(val)
                        }
                    },
                    query: this.querytype !== "add",
                    required: true,
                },
                {
                    label: this.$t("fbb.carrieraccount.logistics_carrier", {
                        defaultValue: "物流商",
                    }),
                    key: "carrierGroupId",
                    tag: "vSelect",
                    options: this.getCustomServiceActiveList.filter(item=>item.attach.regionCode===this.regionId),
                    props: {
                        filterable: true,
                    },
                    show: this.querytype == "add",
                    // query: this.querytype !== "add",
                },
                {
                    label: this.$t("fbb.carrieraccount.logistics_carrier", {
                        defaultValue: "物流商",
                    }),
                    key: "carrierGroupName",
                    query: true,
                    show: this.querytype !== "add",
                },
                {
                    label: this.$t("fbb.carrieraccount.account_type", {
                        defaultValue: "对接类型",
                    }),
                    key: "accountType",
                    tag: "vSelect",
                    options: [
                        { value: 0, label: "Post" },
                        { value: 1, label: "Label" },
                    ],
                    on: {
                        "on-change": (val) => {
                            if (val == 0) {
                                this.formData.labelAccount = "";
                                this.formData.labelPassword = "";
                                this.formData.labelShipperCode = "";
                            } else {
                                this.formData.shippingAccount = "";
                                this.formData.billingAccount = "";
                            }
                        },
                    },
                    query: this.querytype == "query",
                },
                {
                    label: this.$t("fbb.carrieraccount.shipping_account", {
                        defaultValue: "Shipping账号",
                    }),
                    key: isQuery ? "shippingAccount" : "test",
                    required: true,
                    tag: "div",
                    children: (h) => {
                        return h("div", {}, [
                            h("vInput", {
                                props: {
                                    value: this.formData.shippingAccount,
                                },
                                on: {
                                    "on-change": (val) => {
                                        if (typeof val !== "string") return;
                                        // console.log("vinput", val);
                                        this.$set(
                                            this.formData,
                                            "shippingAccount",
                                            val
                                        );
                                        return false;
                                    },
                                },
                            }),
                            h("div", {}, [
                                h(
                                    "vCheckbox",
                                    {
                                        props: {
                                            value: !!this.formData.isDefault,
                                        },
                                        on: {
                                            "on-change": (val) => {
                                                // console.log("vcheckbox", val);
                                                this.$set(
                                                    this.formData,
                                                    "isDefault",
                                                    val
                                                );
                                                return false;
                                            },
                                        },
                                    },
                                    "设为默认账号"
                                ),
                            ]),
                        ]);
                    },
                    show: this.formData.accountType == 0,
                    query: isQuery,
                },
                {
                    label: this.$t("fbb.carrieraccount.billing_account", {
                        defaultValue: "Billing账号",
                    }),
                    key: "billingAccount",
                    tag: "vInput",
                    show: this.formData.accountType == 0,
                    query: this.querytype == "query",
                },
                {
                    label: this.$t("", { defaultValue: "Label登录账户" }),
                    // key: isQuery ? "labelAccount" : "test",
                    // tag: isQuery ? "vInput" : "div",
                    key: "test",
                    tag: "div",
                    required: !isQuery,
                    children: (h) => {
                        let queryEle = h("div", {}, [
                            h(
                                "div",
                                {
                                    style: "font-weight: bold;",
                                },
                                this.formData.labelAccount
                            ),
                            h(
                                "vCheckbox",
                                {
                                    props: {
                                        value: !!this.formData.isDefault,
                                        disabled: true,
                                    },
                                },
                                "设为默认账号"
                            ),
                        ]);
                        let editEle = h("div", {}, [
                            h("vInput", {
                                props: {
                                    value: this.formData.labelAccount,
                                },
                                on: {
                                    "on-change": (val) => {
                                        if (typeof val !== "string") return;
                                        this.$set(
                                            this.formData,
                                            "labelAccount",
                                            val
                                        );
                                        return false;
                                    },
                                },
                            }),
                            h("div", {}, [
                                h(
                                    "vCheckbox",
                                    {
                                        props: {
                                            value: !!this.formData.isDefault,
                                        },
                                        on: {
                                            "on-change": (val) => {
                                                // console.log("vcheckbox", val);
                                                this.$set(
                                                    this.formData,
                                                    "isDefault",
                                                    val
                                                );
                                                return false;
                                            },
                                        },
                                    },
                                    "设为默认账号"
                                ),
                            ]),
                        ]);
                        return isQuery ? queryEle : editEle;
                    },
                    show: this.formData.accountType == 1,
                    // query: isQuery
                },
                {
                    label: this.$t("", { defaultValue: "Label登录密码" }),
                    key: "labelPassword",
                    tag: "vInput",
                    show: this.formData.accountType == 1,
                    query: isQuery,
                },
                {
                    label: "Label Shipper Code",
                    key: "labelShipperCode",
                    tag: "vInput",
                    show: this.formData.accountType == 1,
                    query: isQuery,
                },
                {
                    label:"Label承运商",
                    key:'labelCarrierCode',
                    tag: "vInput",
                    show: this.formData.accountType == 1,
                    query: isQuery,
                },
            ];
        },
    },
    methods: {
        getRegion(val){
            const selectWareHouse= this.warehouseList.filter(item=>item.value===val)[0]
            this.regionId=selectWareHouse.attach.regionId;
        },
        async getLog() {
            await HttpBillingAccountLog({
                id: this.activeid,
            }).then(
                (res) => {
                    this.logList = res.data.orderLogList || [];
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        async getDetail() {
            this.loading = true;
            await HttpGetBillingDetail({
                id: this.activeid,
            }).then(
                (res) => {
                    this.formData = res.data;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },
        async submit() {
            let flag = await this.$refs.form.validate();
            if (!flag) return;
            if (
                this.formData.accountType == 0 &&
                !this.formData.shippingAccount
            )
                return this.$VMessage.warning(
                    this.$t("global.common.fill_required", {
                        defaultValue: "请填写必填项",
                    })
                );
            if (this.formData.accountType == 1 && !this.formData.labelAccount)
                return this.$VMessage.warning(
                    this.$t("global.common.fill_required", {
                        defaultValue: "请填写必填项",
                    })
                );
            this.loading = true;
            // console.log(this.formData);
            await HttpUpdateBillAccountDetail({
                id: this.id,
                ...this.formData,
                isDefault: !!this.formData.isDefault ? 1 : 0,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.$emit("on-update");
                    this.$emit("on-close");
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },
    },
};
</script>

<style>
</style>
